
import Vue from "vue";

import ActivitiesMixin from "@/components/ActivitiesView/ActivitiesMixin.vue";
import ActivitiesTimelineItem from "@/components/ActivitiesView/ActivitiesTimelineItem.vue";

interface CompaniesActivitiesData {
  error: string;
  message: string;
}

export default Vue.extend({
  name: "CompaniesActivitiesView",
  components: { ActivitiesTimelineItem },
  mixins: [ActivitiesMixin],

  data(): CompaniesActivitiesData {
    return {
      error: "",
      message: ""
    };
  },
  computed: {
    queryOverride(): any {
      return {
        name__in: `
          ADD_COMPANY_SUCCESS,
          ADD_COMPANY_FAILURE,
          UPDATE_COMPANY_SUCCESS,
          UPDATE_COMPANY_FAILURE,
          DELETE_COMPANY_SUCCESS,
          DELETE_COMPANY_FAILURE
          `.replace(/\s/g, ""),
        activityType: "CompanyActivity"
      };
    }
  }
});
